import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { EstadoRevisionDiscapacidadDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class EstadoRevisionDiscapacidadService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) { }

  getEstadoRevisionDiscapacidadService(): Observable<BodyListResponse<EstadoRevisionDiscapacidadDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionDiscapacidadDTO>>(API_URL + '/api/v1/estadoRevisionDiscapacidad/todos');
  }

  guardarEstadoRevisionDiscapacidadService(estadoRevisionDiscapacidadDTO: EstadoRevisionDiscapacidadDTO): Observable<EstadoRevisionDiscapacidadDTO> {
    return this.http.post<EstadoRevisionDiscapacidadDTO>(API_URL + '/api/v1/estadoRevisionDiscapacidad', estadoRevisionDiscapacidadDTO);
  }

  getEstadoRevisionDiscapacidadPorCodigoEstadoRevisionDiscapacidadService(codigoEstadoRevisionDiscapacidad: string): Observable<BodyResponse<EstadoRevisionDiscapacidadDTO>> {
    return this.http.get<BodyResponse<EstadoRevisionDiscapacidadDTO>>(API_URL + '/api/v1/estadoRevisionDiscapacidad/' + codigoEstadoRevisionDiscapacidad);
  }

  getEstadoRevisionDiscapacidadPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<EstadoRevisionDiscapacidadDTO>> {
    return this.http.get<BodyListResponse<EstadoRevisionDiscapacidadDTO>>(API_URL + '/api/v1/estadoRevisionDiscapacidad/persona/' + codigoPersona);
  }
}
